import { GetCuentasBancariasByFiltersDtoProps } from "api/DTOs/GetCuentasBancariasByFiltersDto"

/* eslint-disable @typescript-eslint/no-unused-vars */
export const getDropdownBankValues = (
  backAccountList:
    | GetCuentasBancariasByFiltersDtoProps[]
    | null
    | undefined = []
) =>
  backAccountList?.map((bank) => ({
    label: bank.iban,
    value: bank,
  }))

export const getCuentaFromCuentasBancarias = async (
  ctasBancarias: $TSMigrationFixMe,
  id: string
) => {
  const {
    balance,
    fechaUltimaActualizacion,
    logo,
    necesitaValidacion,
    ...resto
  } = await ctasBancarias.find((cta: $TSMigrationFixMe) => cta.id === id)
  return resto
}
